// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import AnimValue from "./AnimValue";

const { ccclass, property, executeInEditMode, requireComponent, menu } = cc._decorator;

@ccclass
@executeInEditMode
@requireComponent(cc.ProgressBar)
@menu('Framework/UI组件/AnimValueProgress')
export default class AnimValueProgress extends AnimValue {

    
	private _progressBar: cc.ProgressBar = null;
	public get progressBar(): cc.ProgressBar {
		if (!this._progressBar) this._progressBar = this.getComponent(cc.ProgressBar);
		return this._progressBar;
	}

	private callback: ()=> void = null;

	// LIFE-CYCLE CALLBACKS:

	// onLoad () {}

	start() {

	}

	setCallback(callback: ()=> void) {
		this.callback = callback;
	}

	/**
	 * @override
	 */
	protected onAnimUpdate(): void {
		this.progressBar.progress = this.curValue;
		this.callback && this.callback();
	}

	// update (dt) {}
}
